<template>
  <ul class="nav" :class="[tabs ? 'nav-tabs' : 'nav-pills']">
    <li
      v-for="(option, i) of options"
      :key="i"
      class="nav-item"
      :class="[
        colour,
        {
          'white-bg': whitePills,
        },
      ]"
    >
      <a
        class="btn nav-link"
        :class="{
          active: modelValue === option.value,
          disabled: option.disabled,
        }"
        @click="handleSelectMode(option)"
      >
        <slot v-if="slots.header" name="header" :option="option" />
        <template v-else>
          <div v-if="option.icon" class="icons">
            <i v-if="typeof option.icon === 'string'" :class="option.icon" />
            <i v-for="(icon, j) of option.icon" v-else :key="j" :class="icon" />
          </div>
          {{ option.displayValue }}
          <InfoPopupComponent v-if="option.experimental" fa-icon="fa-flask" class="position-relative"> Experimentell funktion </InfoPopupComponent>
        </template>
      </a>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import InfoPopupComponent from '@/components/simple/InfoPopupComponent.vue'
import { Option } from '@/models/Global'
import { useSlots } from 'vue'

const slots = useSlots()

const props = defineProps<{
  options?: Option[]
  modelValue?: string
  tabs?: boolean
  whitePills?: boolean
  colour?: 'theme' | 'grey'
}>()
const emit = defineEmits(['update:modelValue', 'change'])

const handleSelectMode = (option: Option) => {
  if (!option.disabled) {
    emit('update:modelValue', option.value)

    if (option.value !== props.modelValue) {
      emit('change', option.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.missing {
  text-decoration: line-through;
}

.white-bg .active {
  background-color: white;
  color: black;
  border-color: var(--light-grey);
  font-weight: bold;
}

.nav-tabs {
  li.nav-item {
    margin-right: 3px;

    a.nav-link {
      color: var(--link-colour);

      &.disabled {
        background-color: #f5f5f5;
      }

      &.active {
        text-shadow: 1px 1px #ddd;
        color: black;
        font-weight: bold;
        border-color: var(--light-grey);
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom-color: #fff;
      }
    }
  }
}

.nav-link {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.icons {
  display: flex;
  $margin: 0.25em;
  margin-right: $margin;
  gap: $margin;
}

.nav-item.theme a.active:not(:disabled) {
  background-color: var(--theme-selected-primary);
}

.nav-item.grey a.active:not(:disabled) {
  /* copied from "included" in topnav */
  background-color: #ececec;
  color: var(--text-colour);
}
</style>
